import React from 'react';

export const InfoInvIcon = ({
    width = 20,
    height = 20,
    fill = 'gray'
}: {
    width?: number;
    height?: number;
    fill?: string;
}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 1.5c-4.686 0-8.5 3.814-8.5 8.5s3.814 8.5 8.5 8.5 8.5-3.814 8.5-8.5-3.814-8.5-8.5-8.5zm-.493 6.56c.628 0 1.112.147 1.452.438.34.293.51.672.51 1.14 0 .096-.012.266-.035.51a3.308 3.308 0 0 1-.13.67l-.65 2.219c-.053.178-.1.381-.144.609a3.11 3.11 0 0 0-.062.518c0 .294.068.495.205.602.136.107.373.16.71.16.159 0 .336-.027.537-.08.2-.053.343-.1.434-.14l-.174.684c-.522.199-.937.35-1.249.454-.31.104-.672.156-1.083.156-.632 0-1.123-.149-1.474-.446a1.417 1.417 0 0 1-.524-1.131c0-.178.013-.36.039-.546.026-.185.068-.394.126-.628l.653-2.224c.057-.214.107-.416.147-.605.04-.19.058-.365.058-.524 0-.283-.06-.481-.182-.593-.123-.112-.354-.167-.698-.167-.168 0-.341.024-.519.075A7.57 7.57 0 0 0 7 9.357l.173-.686c.427-.168.836-.312 1.227-.43.39-.122.76-.181 1.107-.181zm1.3-4.06c.426 0 .791.137 1.093.411.303.274.455.605.455.99 0 .386-.152.716-.455.987a1.583 1.583 0 0 1-1.094.407 1.6 1.6 0 0 1-1.099-.407c-.303-.271-.457-.601-.457-.987 0-.385.154-.716.457-.99a1.588 1.588 0 0 1 1.1-.411z"
            fill={fill}
            fillRule="evenodd"
        />
    </svg>
);
